export default __webpack_public_path__ + "static/media/LTC.cca49a63.png";